<template>
  <nut-form-item :label="label" style="display: block; position: relative">
    <Searchbar v-if="searchStatus" v-model="searchValue" @search="search" />
    <nut-checkbox-group v-model="val" v-if="selectAll">
      <nut-checkbox shape="button" v-for="i in list" :key="i.value" :label="i.value" class="mb-10">
        {{ i.text }}
      </nut-checkbox>
    </nut-checkbox-group>
    <nut-radio-group v-else v-model="val" direction="horizontal">
      <nut-radio shape="button" v-for="i in list" :key="i.value" :label="i.value" class="mb-10">{{
        i.text
      }}</nut-radio>
    </nut-radio-group>
  </nut-form-item>
</template>

<script setup>
const emit = defineEmits(['update:modelValue', 'search'])

const props = defineProps({
  modelValue: {
    type: [Array, String, Boolean]
  },
  selectAll: {
    type: Boolean,
    default: false
  },
  searchStatus: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    require: true
  },
  list: {
    type: Object,
    require: true
  }
})
const { label, modelValue, selectAll, searchStatus } = props
const searchValue = ref('')

function search() {}

function cancel() {
  val.value = JSON.parse(JSON.stringify(oldVal.value))
}
function all() {
  val.value = props.list.map((item) => item.value)
}
const oldVal = ref(modelValue || [])
const val = ref(modelValue)
watch(
  () => props.modelValue,
  (val1) => {
    val.value = val1
  }
)
watch(
  modelValue,
  (val1) => {
    console.log('val1', val1)

    emit('update:modelValue', val1)
  },
  {
    deep: true
  }
)
</script>

<style lang="scss" scoped>
::v-deep .nut-checkbox__button {
  min-width: 80px;
  margin-top: 10px;
  border-radius: 0;
  border: 1px solid #ebedf0 !important;
  background: #fff;
  justify-content: center;
}

::v-deep .nut-checkbox__button--active {
  color: #007296 !important;
  background: #fff2e5 !important;
  border: 1px solid #fff2e5 !important;
}
::v-deep .nut-form-item__label {
  color: #53565a;
}

.selectall {
  position: absolute;
  right: 0;
  top: 20px;
}

::v-deep .nut-searchbar {
  padding: 0 !important;
}
</style>
